import { render, staticRenderFns } from "./empleocompleto.vue?vue&type=template&id=67adac48"
import script from "./empleocompleto.vue?vue&type=script&lang=js"
export * from "./empleocompleto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports